package tta.destinigo.talktoastro.feature_call_consultation.data.response.queue_status

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BeforeUser(
    @SerialName("id") val id: Int, // 73
    @SerialName("name") val name: String, // Riya
    @SerialName("position") val position: Int // 1
)